import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import axios from 'axios';
import LegalFooter from '../components/common/LegalFooter';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-box">
          <div className="login-logo">
            <div className="login-logo-icon">🔑</div>
            <h1>{t('auth.forgotPassword')}</h1>
            <p>Entrez votre courriel pour réinitialiser votre mot de passe</p>
          </div>

          <div className="login-lang">
            <button
              type="button"
              className={`lang-btn ${i18n.language.startsWith('fr') ? 'active' : ''}`}
              aria-pressed={i18n.language.startsWith('fr')}
              onClick={() => i18n.changeLanguage('fr')}
            >
              Français
            </button>
            <button
              type="button"
              className={`lang-btn ${i18n.language.startsWith('en') ? 'active' : ''}`}
              aria-pressed={i18n.language.startsWith('en')}
              onClick={() => i18n.changeLanguage('en')}
            >
              Anglais
            </button>
          </div>

          {success ? (
            <div>
              <div className="alert alert-success alert-wrap" role="status">
                ✓ Un courriel de réinitialisation a été envoyé à <strong className="alert-destination">{email}</strong>.
                Vérifiez votre boîte de réception.
              </div>
              <Link to="/login" className="btn btn-outline w-full" style={{ justifyContent: 'center', marginTop: 16 }}>
                ← Retour à la connexion
              </Link>
            </div>
          ) : (
            <>
              {error && <div className="alert alert-error" role="alert">⚠ {error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="forgot-email">{t('auth.email')}</label>
                  <input
                    id="forgot-email"
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                    placeholder="votre@courriel.ca"
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-full btn-lg"
                  disabled={loading}
                  style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
                >
                  {loading ? t('common.loading') : 'Envoyer le lien'}
                </button>
              </form>

              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <Link
                  to="/login"
                  style={{ fontSize: 14, color: 'var(--primary)', textDecoration: 'none' }}
                >
                  ← Retour à la connexion
                </Link>
              </div>
            </>
          )}
          <LegalFooter />
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
